import { Modal } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { FileIcon } from '../../assets/icons/file'
import logoSvg from '../../assets/icons/logo.svg'
import RecomendAndNextSteps from '../../components/RecomendAndNextSteps/RecomendAndNextSteps'
import { getThemeId } from '../../components/getSubjectId'
import Inflamation from '../../components/inflamation/Inflamation'
import HowToInterpretCharts from '../../components/modals/HowToInterpretCharts'
import ResultsInterpretation from '../../components/resultsInterpretation/ResultsInterpretation'
import { BackBtn } from '../../components/shared/NavigationButtons';

export const Container = styled.div`
  margin: 0px auto;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 10;

  @media (max-width: 1100px) {
    max-width: 600px;
    padding: 0px 20px;
  }
`

export const Title = styled.p`
  color: var(--text-main, #1a1a1a);
  /* Display/L Semibold */
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 52px; /* 130% */
  letter-spacing: 0.8px;
  margin: 0;
`

const Background = styled.div`
  height: 100%;
  width: 100%;
`

export const ReadMore = styled.b`
  cursor: pointer;

  color: var(--primary-40, #3baab0);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.32px;
`

export const Heading = styled.span`
  color: var(--text-main, #1a1a1a);
  /* Header/S Semibold */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.32px;
`
export const List = styled.ul`
  margin-top: 10px;
  li::marker {
    color: #bfbfbf;
    font-size: 16px;
  }
`
export const Li = styled.li``

export const BiomarkersContainer = styled.div`
  width: 100%;

  margin-top: 20px;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-column-gap: 20px;
  grid-row-gap: 20px;
`

export const ScrollWrapper = styled.div`
  height: 100%;
  width: 100%;

  overflow-y: scroll;
  overflow-x: hidden;

  position: relative;

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 100px;
  }
  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px rgb(0 0 0 / 46%);
    border-radius: 100px;
  }
`

export const ModalMUI = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
`

export const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  padding: 20px;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`

export const HeaderButtons = styled.span`
  white-space: nowrap;
  color: var(--text-main, #1A1A1A);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
`

const PrintButtonWrap = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`

const PrintLogo = styled.div`
  position: fixed;
  right: 24px;
  top: 24px;
  z-index: 9999;
  display: none;

  @media print {
    display: flex !important;
  }

  svg {
    width: 120px;
    height: auto;
  }
`


export const SubjectName = () => {
  const { t } = useTranslation()
  return <span className={'linkSpan'} data-fade>{t('goBack')}
  </span>
}

const Indicator = (props: any) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isMobile = window.innerWidth <= 600;
  let { info } = props
  let themeId = getThemeId()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <div>
       <div className={'wrapTitleNav'} style={{ padding: '20px 16px' }}>
          <button 
              className="mytitle mainNavLink"
              style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
              onClick={() => window.history.back()}
          >
              <BackBtn></BackBtn>
              <SubjectName></SubjectName>
          </button>
           <div className="brnsNextWrap" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: 20 }}>
               <HeaderButtons onClick={() => setIsModalOpen(true)}>{t('howToInterpretCharts')}</HeaderButtons>
               <PrintButtonWrap>
                <HeaderButtons
                   onClick={() => {
                     window.print()
                   }}
                   style={{ borderLeft: '1px solid #e0e0e0', paddingLeft: '20px' }}
                >
                  <FileIcon style={{marginRight: '5px'}}/>
                  {t('printPage')}
                </HeaderButtons>
               </PrintButtonWrap>
            </div>
      </div>
      
      <Inflamation themeId={themeId} info={info}/>

      <div className="page-break"></div>
      
      <ResultsInterpretation themeId={themeId} info={info}></ResultsInterpretation>
      <RecomendAndNextSteps themeId={themeId} info={info}></RecomendAndNextSteps>
      
      <ModalMUI
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <ModalContent>
          <HowToInterpretCharts onClose={() => setIsModalOpen(false)} />
        </ModalContent>
      </ModalMUI>
      <PrintLogo>
        <img src={logoSvg} alt="Logo" />
      </PrintLogo>
    </div>
  )
}

export default Indicator
